import {toast} from '@wandb/weave/common/components/elements/Toast';
import {Link} from '@wandb/weave/common/util/links';
import {Button} from '@wandb/weave/components';
import * as Dialog from '@wandb/weave/components/Dialog';
import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';

import {useTriggerFlatRunsMigratorMutation} from '../../generated/graphql';

export type RunsV2TargetType = 'entity' | 'organization';

interface TriggerRunsV2ModalProps {
  name: string;
  type: RunsV2TargetType;
  isOpen: boolean;
  onClose: () => void;
}

const TriggerRunsV2Modal: React.FC<TriggerRunsV2ModalProps> = ({
  name,
  type,
  isOpen,
  onClose,
}) => {
  const [triggerMigrator, {loading}] = useTriggerFlatRunsMigratorMutation();

  const handleTriggerMigrator = async () => {
    if (!name) {
      toast(`${type} name is required`);
      return;
    }

    try {
      const {data} = await triggerMigrator({
        variables: {
          organizationName: type === 'organization' ? name : undefined,
          entityName: type === 'entity' ? name : undefined,
        },
      });

      const glueTaskName = data?.triggerFlatRunsMigrator?.glueTaskName;
      if (glueTaskName) {
        toast(
          <span>
            Successfully triggered Runs V2 migration task. Check out{' '}
            <Link to={`/admin/glue?search=${glueTaskName}`}>here</Link>
          </span>
        );
      }
      onClose();
    } catch (error) {
      console.error('Failed to trigger runs v2 migration:', error);
      toast(`Failed to trigger migration: ${error}`);
    }
  };

  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay />
        <Dialog.Content className="w-[600px] rounded-lg">
          <Dialog.Title>
            <div className="flex items-center">
              <Icon name="warning-alt" className="mr-10" />
              Migrate to Runs V2
            </div>
          </Dialog.Title>
          <Dialog.Description className="pt-16">
            Are you sure you want to trigger Runs V2 migration for {type}{' '}
            <b>{name}</b>? This might take a while.
          </Dialog.Description>
          <div className="mt-24 flex justify-end gap-8">
            <Dialog.Close>
              <Button
                onClick={handleTriggerMigrator}
                variant="primary"
                size="large"
                disabled={loading}>
                {loading ? 'Triggering...' : 'Trigger'}
              </Button>
            </Dialog.Close>
            <Dialog.Close>
              <Button onClick={onClose} variant="ghost" size="large">
                Cancel
              </Button>
            </Dialog.Close>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default TriggerRunsV2Modal;
